import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ArrowRightIcon, RefreshIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { globalConst } from 'modules/global';
import { lessonConst, setLessonStatus, setPaymentModal, useLessonResult } from 'modules/lesson-detail';

import { ScoreCard } from './score-card';
import { Skeleton } from './skeleton';

export const Result = ({ isBought }: { isBought?: boolean }) => {
  const t = useTranslations();
  const qc = useQueryClient();
  const dispatch = useAppDispatch();
  const { query, push } = useRouter();
  const { results, isLoading } = useLessonResult(query?.lesson as string);

  const onRetry = () => {
    dispatch(setLessonStatus(lessonConst.LessonStatus.SEEN));
  };

  const onNext = () => {
    if (!isBought) {
      return dispatch(setPaymentModal(true));
    }

    qc.invalidateQueries({ queryKey: [lessonConst.queryKeys.LESSONS_LIST, query?.course as string] });
    return push(`${globalConst.pageNames.COURSES}/${query?.course}/${results?.next?.slug}`);
  };

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <div className="my-10">
      <div className="flex items-center justify-center gap-4">
        <ScoreCard type="correct" score={results?.right} text={t('togri_javoblar')} />
        <ScoreCard type="wrong" score={results?.wrong} text={t('notogri_javoblar')} />
        <ScoreCard type="percent" score={results?.earned_ball} text={t('jami_yechilgan')} />
      </div>

      <div className="mt-8 flex items-center justify-center gap-3 text-sm">
        <button
          onClick={onRetry}
          className="flex cursor-pointer items-center justify-center gap-2 rounded-lg bg-purple-600 px-5 py-3 text-white"
        >
          <RefreshIcon /> {t('qayta_ishlash')}
        </button>
        {results?.next?.slug ? (
          <button
            onClick={onNext}
            className="flex cursor-pointer items-center justify-center gap-2 rounded-lg bg-green-500 px-5 py-3 text-white disabled:cursor-not-allowed disabled:opacity-50"
          >
            {t('keyingi_dars')} <ArrowRightIcon />
          </button>
        ) : null}
      </div>
    </div>
  );
};
